import { render, staticRenderFns } from "./WidgetNewsletter.vue?vue&type=template&id=26d287c8&"
import script from "./WidgetNewsletter.vue?vue&type=script&lang=js&"
export * from "./WidgetNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports